"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCancellationReason = exports.initialized = exports.cancel = void 0;
exports.cancel = '@event/CANCEL';
exports.initialized = '@event/INITIALIZED';
exports.selectCancellationReason = '@event/SELECT_CANCELLATION_REASON';
//# sourceMappingURL=Events.js.map